export var ServiceNameType;
(function (ServiceNameType) {
    ServiceNameType["Proclean"] = "ProClean";
    ServiceNameType["ProcleanPlus"] = "ProClean PLUS";
    ServiceNameType["Cellarplus"] = "Cellarplus";
    ServiceNameType["ChillPour"] = "Chill Pour";
    ServiceNameType["ProspecJdw"] = "ProSpec JDW";
    ServiceNameType["Winterization"] = "Winterization";
    ServiceNameType["Dewinterization"] = "Dewinterization";
    ServiceNameType["SosLv1"] = "SOS Lv1";
    ServiceNameType["SosLv2"] = "SOS Lv2";
    ServiceNameType["SosLv3"] = "SOS Lv3";
})(ServiceNameType || (ServiceNameType = {}));
